import ServiceBase from "base/baseService"

export default class VariavelService extends ServiceBase {

    title = "Variável"
    pluralTitle = "Variáveis"
    url = '/cadastro/outros/variavel'
    frontUrl = '/cadastro/outros/variavel'
    frontUrlList = '/cadastro/outros/variavellist'
    primaryKey = 'codigo_var'

    prepareToFront(data = {}) {
        data.descricao_var = data?.descricao_var || ''
        data.nome_var = data?.nome_var || ''
        data.valor_var = data?.valor_var || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }
}
